import { ExtractedStructuredTextHeading } from 'utils/structured-text.utils';

import { PagePrivacyPolicyFragment } from 'types/api/dato-operations.types';

import CustomPageText from 'components/@custom-pages/CustomPageText';
import CustomPageTextIndexBlock from 'components/@custom-pages/CustomPageTextIndexBlock';
import LongFormTemplate from 'components/@custom-pages/LongformTemplate';
import UpdatedAtSeparator from 'components/@custom-pages/UpdatedAtSeparator';

interface Props {
  title: PagePrivacyPolicyFragment['title'];
  updatedAt: PagePrivacyPolicyFragment['updatedAt'];
  body: PagePrivacyPolicyFragment['body'];
  headings?: Array<ExtractedStructuredTextHeading> | null;
}

const CustomPageTextContainer = ({
  title,
  body,
  updatedAt,
  headings,
}: Props) => {
  return (
    <>
      <CustomPageText
        sidebar={
          <CustomPageTextIndexBlock headings={!!headings ? headings : []} />
        }
        title={title}
      >
        <LongFormTemplate body={body} sx={{ mb: 5 }} />
        <UpdatedAtSeparator dateTime={updatedAt} sx={{ xs: 3, md: 4 }} />
      </CustomPageText>
    </>
  );
};

export default CustomPageTextContainer;
